module.exports = {
  defaultTitle: 'Hindisvík',
  logo: '',
  author: 'KN',
  // Punycode form of https://www.hindisvík.is, used for canonical URLs, the sitemap and structured data
  url: 'https://www.xn--hindisvk-i2a.is',
  defaultDescription:
    'Hindisvík er í einkaeign og eina jörðin á Íslandi sem ber þetta nafn. Eigendur Hindisvíkur eru Anna Norland og Helga Norland, Kristín Norland, Jón Norland og Halla Norland.',
  defaultDescriptionEn:
    'Hindisvík is a privately owned farm on the tip of Vatnsnes in northwest Iceland, and the only farm in Iceland bearing that name. Its owners are Anna Norland, Helga Norland, Kristín Norland, Jón Norland and Halla Norland.',
  socialLinks: {
    twitter: null,
    github: null,
    linkedin: null,
    instagram: null,
    youtube: null,
    google: null,
  },
  // GoatCounter (cookie-free, so no consent banner is needed). Only loaded in production builds; null disables it.
  goatCounterUrl: 'https://kristjannorland.goatcounter.com/count',
  themeColor: '#2f5d73',
  backgroundColor: '#ffffff',
  social: {
    facebook: null,
    twitter: null,
  },
  address: {
    locality: 'Vatnsnes',
    region: 'Húnaþing vestra',
    country: 'IS',
  },
  // The farmhouse, from OpenStreetMap
  geo: {
    latitude: 65.6758,
    longitude: -20.6948,
  },
  contact: {
    email: 'jonn@sminor.is',
  },
  foundingDate: null,
};
